import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_Cockpit_DDX.scss';
import { scrub, sortArray } from '@nu-art/ts-common';
import { Component_ProtocolDDXScore } from '../../next-steps/protocol-ddx-score/Component_ProtocolDDXScore.js';
import { FadeScrollWrapper } from '@app/styles';
import { ICONS } from '@app/styles';
export class Component_Cockpit_DDX extends ComponentSync {
    ref = React.createRef();
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.diagnosisData = nextProps.protocols.map(p => p.getDiagnosisData()).flat();
        sortArray(state.diagnosisData, data => data.protocol.careMapOutcomes?.[data.diagnosis._id]?.sortingIndex);
        state.focusedDiagnosisId = nextProps.focusedDiagnosisId;
        return state;
    }
    componentDidMount() {
        this.deriveDDXWidth();
    }
    //######################### Logic #########################
    deriveDDXWidth = () => {
        const current = this.ref.current;
        if (!current)
            return;
        const rect = current.getBoundingClientRect();
        //Reduce scale width by 32 for panel padding, and another 32 for card padding
        const width = rect.width - 64;
        this.setState({ ddxWidth: width });
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'cockpit-panel cockpit-ddx', innerRef: this.ref, children: [this.render_Header(), _jsx(FadeScrollWrapper, { children: this.state.diagnosisData.map(this.render_Diagnosis) })] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'cockpit-panel__header', children: ["DDx", _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.closeDialog })] });
    };
    render_Diagnosis = (diagnosisData) => {
        const diagnosisId = diagnosisData.diagnosis._id;
        const style = scrub({ '--dp-color': diagnosisData.getColor() });
        const className = _className('cockpit-ddx__protocol-wrapper', diagnosisId === this.state.focusedDiagnosisId && 'focused');
        const label = diagnosisData.pathway.variableIds.length === 1 ? diagnosisData.pathway.label : diagnosisData.diagnosis.name;
        return _jsxs(LL_V_L, { className: className, style: style, onClick: () => this.props.focusDiagnosis(diagnosisData), children: [_jsx("div", { className: 'cockpit-ddx__protocol-wrapper__title', children: label }), _jsx(Component_ProtocolDDXScore, { protocol: diagnosisData.protocol, width: this.state.ddxWidth ?? 0, variant: 'concise', diseaseId: diagnosisData.diagnosis._id })] }, diagnosisData.diagnosis._id);
    };
}
//# sourceMappingURL=Component_Cockpit_DDX.js.map